var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82302 3.47828C4.88381 3.31399 5.11619 3.31399 5.17698 3.47828C5.75038 5.02787 6.97213 6.24962 8.52172 6.82302C8.68601 6.88381 8.68601 7.11619 8.52172 7.17698C6.97213 7.75038 5.75038 8.97213 5.17698 10.5217C5.11619 10.686 4.88381 10.686 4.82302 10.5217C4.24962 8.97213 3.02787 7.75038 1.47828 7.17698C1.31399 7.11619 1.31399 6.88381 1.47828 6.82302C3.02787 6.24962 4.24962 5.02787 4.82302 3.47828Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82724 1.46687C8.88659 1.30649 9.11341 1.30649 9.17276 1.46687C9.40597 2.09712 9.90288 2.59403 10.5331 2.82724C10.6935 2.88659 10.6935 3.11341 10.5331 3.17276C9.90288 3.40597 9.40597 3.90288 9.17276 4.53313C9.11341 4.69351 8.88659 4.69351 8.82724 4.53313C8.59403 3.90288 8.09712 3.40597 7.46687 3.17276C7.30649 3.11341 7.30649 2.88659 7.46687 2.82724C8.09712 2.59403 8.59403 2.09712 8.82724 1.46687Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseAi);
export default __webpack_public_path__ + "static/media/useAi.66ee82f60f26f237016cf80601d1de34.svg";
export { ForwardRef as ReactComponent };